import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { toasterOff } from '../../store/actions';

import './Toastr.scss';

const Toastr = ({ type, message }) => {
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Trigger enter animation
    setTimeout(() => setIsVisible(true), 10);

    // Start exit animation before hiding
    const exitTimer = setTimeout(() => {
      setIsExiting(true);
    }, 2700);

    // Actually hide after animation
    const hideTimer = setTimeout(() => {
      dispatch(toasterOff({ type: '', message: '' }));
    }, 3000);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(hideTimer);
    };
  }, [dispatch]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      dispatch(toasterOff({ type: '', message: '' }));
    }, 300);
  };

  const isSuccess = type !== 'failed';

  return (
    <div 
      className={`toast-notification ${isVisible ? 'toast-notification--visible' : ''} ${isExiting ? 'toast-notification--exiting' : ''} ${isSuccess ? 'toast-notification--success' : 'toast-notification--error'}`}
      onClick={handleClose}
    >
      <div className="toast-notification__icon">
        {isSuccess ? (
          <i className="fas fa-check-circle" />
        ) : (
          <i className="fas fa-exclamation-circle" />
        )}
      </div>
      
      <div className="toast-notification__content">
        <h4 className="toast-notification__title">
          {isSuccess ? 'Success!' : 'Something went wrong'}
        </h4>
        <p className="toast-notification__message">
          {typeof message === 'object' && message !== null
            ? message.message || JSON.stringify(message)
            : message}
        </p>
      </div>

      <button type="button" className="toast-notification__close" onClick={handleClose}>
        <i className="fas fa-times" />
      </button>

      <div className="toast-notification__progress" />
    </div>
  );
};

export default Toastr;
